import React from "react";

export interface CategorySpansProps {
  /** Category labels to render as badges. Each value is used as both the key and the displayed text. */
  categories: string[];
}

/**
 * Renders a row of light-background, primary-text badge spans — one per
 * category. Used on resource and guide cards to surface their categories.
 *
 * No spacing wrapper is rendered; callers control layout (typically with a
 * flex container using `gap-*` utilities).
 */
export default function CategorySpans({ categories }: CategorySpansProps) {
  return (
    <>
      {categories.map((cat) => (
        <span
          key={cat}
          className="badge bg-light text-primary border"
          style={{ fontSize: "0.7rem", fontWeight: 500 }}
        >
            {cat}
          </span>
      ))}
    </>
  );
}
